import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

export interface IListagem {
  idcaixa: string;
  idconta: number;
  numero: string;
  nome: string;
  dataoperacao: Date;
  historico: string;
  entrada: number;
  saida: number;
  idpareceiro: string;
  idoperacao: string;
  tipo: string;
  datalan: Date;
  status: boolean;
  tipos: number;
}

export interface IResultado{
  saldoanterior: number;
  credito: number;
  debito: number; 
  saldo: number;
  valorcheque: number;
  saldoreal: number;
}

interface IFecharCaixa {
  conta: number;
  datafechar: Date;
}

interface IAbrirCaixa {
  conta: number;
  dataabrir: Date;
}

export interface IVoltarLancamento {
  idoperacao: string;
  datacaixa: Date;
  idconta: number;
  tipos: number;
}


type TotalCount = {
    resultado: IResultado,
    lan: IListagem[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, tipo: string, conta: string, datainicial = '', datafinal=''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/caixa?page=${page}&limit=${12}&tipo=${tipo}&conta=${conta}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data, headers } = await ApiFinanceira.get(urlRelativa); 

    if (data) {
      return {
        resultado: data[0],
        lan: data[1],
        totalCount: Number(headers['x-total-count'] || 12),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const FecharCaixa = async (dados: IFecharCaixa): Promise<string | Error> => {
  try {

    const { data } = await ApiFinanceira.post<IFecharCaixa>('/fecharconciliacao',  dados);
  
    if (Object.keys(data).length === 0) {
      return 'ok';
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const AbrirCaixa = async (dados: IAbrirCaixa): Promise<string | Error> => {
  try {

    const { data } = await ApiFinanceira.post<IAbrirCaixa>('/abrirconciliacao',  dados);
  
    if (Object.keys(data).length === 0) {
      return 'ok';
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const VoltarLancamento = async (dados: IVoltarLancamento): Promise<string | Error> => {
  try {

    const { data } = await ApiFinanceira.post<IAbrirCaixa>('/voltarlancamento',  dados);
  
    if (Object.keys(data).length === 0) {
      return 'ok';
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const CaixaConstasService = {  
  getAll,
  FecharCaixa,
  AbrirCaixa,
  VoltarLancamento,
};